import { ApiRequestInterceptor } from "./apiRequest";
import { USERS } from "../Constants/Endpoints";

export const fetchLogin = async (body) => {
  const { code, data } = await ApiRequestInterceptor(USERS.login, "POST", body);
  return {
    statusCode: code,
    message: data?.message,
    token: data?.token ?? data?.data?.token,
    role: data?.role ?? data?.data?.role,
    userId: data?.userId ?? data?.data?.userId,
    data,
  };
};
